import { Component } from "@angular/core";
import { FieldType, FormGlobalService } from "@kre-form/core";

@Component({
  selector: "kreform-tabular",
  template: `
    <div class="tabular">
      <div class="tabular-header">
        <div class="col-no">序号</div>
        <div
          class="col-default"
          *ngFor="let header of to.fieldGroup; let i = index"
        >
          {{ header.templateOptions.label }}
        </div>
        <div class="col-operation">操作</div>
      </div>
      <div class="tabular-body">
        <div class="row" *ngFor="let row of field.fieldGroup; let i = index">
          <div class="col-no">{{ i }}</div>
          <div class="col-default">
            <kreform-field [field]="row"></kreform-field>
          </div>
          <div class="col-operation"><a (click)="delete(i)">删除</a></div>
        </div>
      </div>
    </div>
    <a (click)="add()">新增</a>
  `,
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: "",
  },
})
export class KreFormFieldTabular extends FieldType {
  constructor(private globalService: FormGlobalService) {
    super();
  }
  add() {
    this.globalService.notifyDataChanged("TabularAdd", {
      rdm: Math.random(),
      config: this.field,
    });
  }
  delete(i: any) {
    this.globalService.notifyDataChanged("TabularDel", {
      rdm: Math.random(),
      config: this.field,
      number: i,
    });
  }
  get rows() {
    let res: any[] = [];
    for (let key in this.model) {
      let obj: any = {
        key: key,
      };
      if (this.field && this.field.fieldGroup) {
        obj["config"] = this.field.fieldGroup.filter((item: any) => {
          return item.key == key;
        })[0];
      }
      res.push(obj);
    }
    return res;
  }
}
